<template>
  <div class="add-base">
    <Card>
      <h2 v-if="!baseInfo.id" style="text-align: center;margin:20px 0 0 0;">新增应急库</h2>
      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急库</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="仓库名称" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写仓库名称"></Input>
          </FormItem>
          <FormItem label="负责人" prop="personInCharge">
            <Input v-model="formValidate.personInCharge" placeholder="请填写负责人"></Input>
          </FormItem>
          <FormItem label="负责人手机" prop="personInChargePhone">
            <Input v-model="formValidate.personInChargePhone" placeholder="请填写负责人手机"></Input>
          </FormItem>
          <FormItem label="负责单位" prop="responsibleUnitId">
            <TreeSelect v-model="formValidate.responsibleUnitId" placeholder="请选择单位" class="treeSelect" transfer
                        clearable :data="unitList"/>
          </FormItem>
          <FormItem label="值班电话" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写负责值班电话"></Input>
          </FormItem>
          <FormItem label="仓库类型" prop="storeHouseType">
            <Select v-model="formValidate.storeHouseType" placeholder="请选择仓库类型">
              <Option :value="1">物资库</Option>
              <Option :value="2">机械设备库</Option>
            </Select>
          </FormItem>
          <FormItem label="面积（平方米）" prop="squareMeter">
            <Input v-model="formValidate.squareMeter" placeholder="请填写面积"></Input>
          </FormItem>
          <FormItem label="详细地址" prop="address">
            <Input v-model="formValidate.address" placeholder="请填写详细地址"></Input>
          </FormItem>
          <FormItem label="负责单位行政区域" prop="responsibleAreaId">
            <Row :gutter="4">
              <Col :span="10">
                <FormItem>
                  <Select transfer clearable :disabled="countryList.length === 1" v-model="formValidate.responsibleAreaId" @on-change="getStreeByCountryId"
                          placeholder="区县">
                    <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!--              <Col :span="10">-->
              <!--                <FormItem prop="responsibleStreetId">-->
              <!--                  <Select transfer clearable v-model="formValidate.responsibleStreetId" placeholder="街道">-->
              <!--                    <Option v-for="(item) in streetList" :key="item.id" :value="item.id">{{item.name}}</Option>-->
              <!--                  </Select>-->
              <!--                </FormItem>-->
              <!--              </Col>-->
            </Row>
          </FormItem>
          <FormItem label="经纬度" prop="longitude">
            <Row :gutter="4">
              <Col :span="3">
                <Button type="primary" @click="getLocationByMap">定位</Button>
              </Col>
              <Col :span="8">
                <FormItem prop="longitude">
                  <Input v-model="formValidate.longitude" placeholder="请填写经度"></Input>
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem prop="dimension">
                  <Input v-model="formValidate.dimension" placeholder="请填写纬度"></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="仓库简要概述" prop="introduce">
            <Input v-model="formValidate.introduce" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <!--          <FormItem>-->
          <!--            <Button v-if="!baseInfo.id" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="baseInfo.id" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!baseInfo.id" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">新增
          </Button>
          <Button v-if="baseInfo.id" :loading="saveLoading" type="primary" @click="editTeam('formValidate')">编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="goBack" type="primary" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>

    <Modal
        v-model="modal"
        title="地图"
        @on-ok="ok"
        @on-cancel="cancel">
      <div style="margin-bottom: 10px">
        <AutoComplete
            transfer
            clearable
            v-model="searchPlace"
            @on-search="handleSearch"
            placeholder="请输入搜索地址"
            style="width:200px">
          <Option v-for="item in searchList" :value="item.title" :key="item.uid">{{ item.title }}</Option>
        </AutoComplete>
        <Button type="primary" @click="getLocal">搜索</Button>
      </div>

      <div id="map" style="width: 100%;height: 400px"></div>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "addEmBase",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必填'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      saveLoading: false,
      unitList: [],
      searchPlace: '',
      searchList: [],
      modal: false,
      eventList: [],
      baseInfo: {},
      streetList: [],
      countryList: [],
      formValidate: {
        name: '',
        responsibleUnitId: '',
        personInCharge: '',
        personInChargePhone: '',
        dutyTelephone: '',
        squareMeter: '',
        storeHouseType: '', //仓库类型
        establishedTime: '',
        responsibleAreaId: '',
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remarks: '',
        annex: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        responsibleUnitId: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        personInCharge: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        personInChargePhone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        dutyTelephone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        squareMeter: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        storeHouseType: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        establishedTime: [
          { required: true, type: 'date', message: '必填', trigger: 'blur' }
        ],
        responsibleAreaId: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        responsibleStreetId: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        longitude: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        dimension: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        applicableEventTypes: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        superviseLevel: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        annex: [
          { required: true, message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // this.getAllEvents()
    this.getCountry()
    this.getAllUnit()
    if (this.$route.params.row) {
      this.baseInfo = this.$route.params.row.storeHouse
      this.baseInfo.responsibleAreaId = this.baseInfo.responsibleAreaId.toString()
      this.getStreeByCountryId(this.baseInfo.responsibleAreaId)
      this.baseInfo.responsibleStreetId = this.baseInfo.responsibleStreetId.toString()
      this.formValidate = this.baseInfo
    }
  },
  methods: {
    goBack(){
      // 跳转关闭当前页
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'emergencyBase'
      })
    },
    ok() {
      this.formValidate.longitude = this.local[0].point.lat
      this.formValidate.dimension = this.local[0].point.lng
    },
    cancel() {
    },
    handleSearch(str) {
      setTimeout(() => {
        const _this = this
        var options = {
          onSearchComplete: function (res) { //检索完成后的回调函数
            var s = [];
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              for (var i = 0; i < res.getCurrentNumPois(); i++) {
                s.push(res.getPoi(i));
              }
              // console.log(s)
              _this.searchList = s
            } else {
              _this.searchList = s
            }
          }
        }
        var local = new _this.BMap.LocalSearch(_this.map, options) //创建LocalSearch构造函数
        local.search(str) //调用search方法，根据检索词str发起检索
      }, 1000)
    },
    getLocal() {
      console.log(this.searchPlace)
      this.local = this.searchList.filter(item => item.title === this.searchPlace && item.type === 0)
      console.log(this.local)
      if (this.local.length > 0) {
        for (var i = 0; i < this.local.length; i++) {
          var lat = this.local[i].point.lat // 经度
          var lng = this.local[i].point.lng // 纬度
          var point = new this.BMap.Point(lng, lat)
          var marker = new this.BMap.Marker(point)
          this.map.addOverlay(marker);
          this.map.centerAndZoom(point, 16)
        }
      }
    },
    initBMap() {
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.Map.addOverlay(marker);
      })
    },
    getLocationByMap() {
      this.modal = true
      this.initBMap()
    },
    getAllUnit() {
      this.$http.get('/api/unit/getAll').then(res => {
        // console.log(res)
        this.unitList = res.data.data
        console.log(this.unitList)
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.formValidate.responsibleAreaId = res.data[0].indexCode
        }
      })
    },
    getStreeByCountryId(value) {
      // this.getStreet(value)
    },
    //根据区县获取街道
    getStreet(id) {
      this.$http.get(`/api/street/${id}`).then(res => {
        console.log(res)
        this.streetList = res.data.data
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          console.log(this.formValidate)
          this.$http.post('/api/storehouse/storeHouses', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyBase'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.put('/api/storehouse/storeHouses', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyBase'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.add-base {

}
</style>
